import React from "react"
import PropTypes from "prop-types"
import {isEmpty} from "lodash"

import {Hr} from "@irati/ui/src/Layout"
import Markdown from "@irati/ui/src/Markdown"
import {FormattedMessage} from "@irati/utils/lang"
import {H4} from "@irati/ui/src/Typography"

const ContactInfo = ({deal, showHr}) => {
  if (isEmpty(deal.contactInfo)) return null
  return (
    <section data-test="contact">
      {showHr && <Hr large />}
      <H4 marginBottom={2}><FormattedMessage id="perks.components.dealInfoBlock.contactInfo.text" /></H4>
      <Markdown source={deal.contactInfo} overflowWrap="break-word" />
    </section>)
}

ContactInfo.propTypes = {
  deal: PropTypes.shape({
    contactInfo: PropTypes.string
  }).isRequired,
  showHr: PropTypes.bool
}
ContactInfo.defaultProps = {
  showHr: true
}
export default ContactInfo
